import auth from "../../middlewares/auth";

export const contactRoutes = [
    {
        path: '/contacts/:company_id?',
        component: () => import(/* webpackChunkName: "contacts" */ '../../views/contacts/Contact'),
        name: 'contacts',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['contact-manage']
        }
    },
    {
        path: '/contact/:id',
        component: () => import(/* webpackChunkName: "contacts" */ '../../views/contacts/ContactForm'),
        name: 'update-contact',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['contact-manage']
        }
    },
    {
        path: '/create-contact',
        component: () => import(/* webpackChunkName: "contacts" */ '../../views/contacts/ContactForm'),
        name: 'create-contact',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['contact-manage']
        }
    },
    {
        path: '/contact/:id/show',
        component: () => import(/* webpackChunkName: "contacts" */ '../../views/contacts/ViewContact'),
        name: 'view-contact',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['contact-manage']
        }
    },
]